import { ModalCardButtonActions } from '../../constants/ModalCardButtonType';
import { EVENTS_NEW_REQUEST, EVENTS_SHOW_FOOTER } from '../../constants/events';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const MODAL_CLOSED = 'MODAL_CLOSED';
export const TOGGLE_NEW_REQUEST_MODAL = 'TOGGLE_NEW_REQUEST_MODAL';
export const CONFIRM_LEAVE_MODAL_CLOSED = 'CONFIRM_LEAVE_MODAL_CLOSED';
export const HIDE_TRIAL_BAR = 'HIDE_TRIAL_BAR';
export const SHOW_CERTIFIED_FILE_MODAL = 'SHOW_CERTIFIED_FILE_MODAL';
export const HIDE_FIXED_NOTIFICATIONS_WRAPPER = 'HIDE_FIXED_NOTIFICATIONS_WRAPPER';
export const SET_DASHBOARD_NEW_REQUEST_MODAL = 'SET_DASHBOARD_NEW_REQUEST_MODAL';

export type eventShowFooterAction = {
    type: typeof EVENTS_SHOW_FOOTER;
    payload: { data: CustomEvent<unknown> };
};
export type getEventDataAction = {
    type: typeof EVENTS_NEW_REQUEST;
    payload: string;
};

export type addNotificationAction = {
    type: typeof ADD_NOTIFICATION;
    payload: CustomEvent<{ content: string }>;
};

export type removeNotificationAction = {
    type: typeof REMOVE_NOTIFICATION;
};

export type modalClosedAction = {
    type: typeof MODAL_CLOSED;
    payload: CustomEvent<unknown>;
};

export type confirmLeaveModalClosedAction = {
    type: typeof CONFIRM_LEAVE_MODAL_CLOSED;
    payload: CustomEvent<unknown>;
};

export type toggleNewRequestModalAction = {
    type: typeof TOGGLE_NEW_REQUEST_MODAL;
    payload: { status: boolean };
};

export type showCertifiedFileModalAction = {
    type: typeof SHOW_CERTIFIED_FILE_MODAL;
    payload: boolean;
};

export type hideTrialBarAction = {
    type: typeof HIDE_TRIAL_BAR;
    payload: { hideTrialBar: boolean };
};

export type hideFixedNotificationWraperAction = {
    type: typeof HIDE_FIXED_NOTIFICATIONS_WRAPPER;
    payload: { hideFixedNotificationsWrapper: boolean };
};

export type dashboardNewRequestModalAction = {
    type: typeof SET_DASHBOARD_NEW_REQUEST_MODAL;
    payload: {
        open: boolean;
        requestOrigin: keyof ModalCardButtonActions;
    };
};

export type EventDataTypesActions =
    | eventShowFooterAction
    | getEventDataAction
    | hideFixedNotificationWraperAction
    | showCertifiedFileModalAction
    | hideTrialBarAction
    | confirmLeaveModalClosedAction
    | toggleNewRequestModalAction
    | modalClosedAction
    | addNotificationAction
    | removeNotificationAction
    | dashboardNewRequestModalAction;
